const  getHourMinutes = ($minutes) =>{
    if($minutes>59) {
        return `${Math.floor($minutes/60)}h ${Math.floor($minutes%60)}m`
      } else {
        return `${$minutes}m`
      }
}

export default getHourMinutes;
